import "./scss/index.scss";

import classNames from "classnames";
import * as React from "react";
import { Link } from "react-router-dom";

import { generateCategoryUrl } from "../../core/utils";

import {
  ProductsList_categories,
  ProductsList_shop,
  ProductsList_shop_homepageCollection_backgroundImage,
} from "./gqlTypes/ProductsList";

import { structuredData } from "../../core/SEO/Homepage/structuredData";

import NoPhotoImg from "../../images/no-photo.svg";
import {
  categoryImageUrl,
  visibleHomeCategoryEdges,
} from "./categorySelection";

const Page: React.FC<{
  loading: boolean;
  categories: ProductsList_categories;
  backgroundImage: ProductsList_shop_homepageCollection_backgroundImage;
  shop: ProductsList_shop;
}> = ({ loading, categories, backgroundImage, shop }) => {
  const visibleCategories = visibleHomeCategoryEdges(categories);

  return (
    <>
      <script className="structured-data-list" type="application/ld+json">
        {structuredData(shop)}
      </script>
      {visibleCategories.length > 0 && (
        <section className="home-page__categories">
          <div className="container">
            <h1>Shop by category</h1>
            <div className="home-page__categories__list">
              {visibleCategories.map(({ node: category }) => {
                const imageUrl = categoryImageUrl(category);

                return (
                  <div key={category.id}>
                    <Link
                      aria-label={`Shop ${category.name}`}
                      to={generateCategoryUrl(category.id, category.name)}
                    >
                      <div
                        aria-hidden="true"
                        className={classNames(
                          "home-page__categories__list__image",
                          {
                            "home-page__categories__list__image--no-photo": !imageUrl,
                          }
                        )}
                        style={{
                          backgroundImage: `url(${imageUrl || NoPhotoImg})`,
                        }}
                      />
                      <h3>{category.name}</h3>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}
      <div aria-hidden="true" className="home-page__craft" />
      <section aria-label="Why shop EGT Supplies" className="home-page__trust">
        <div className="container home-page__trust__list">
          <article className="home-page__trust__item">
            <h3>Professional quality</h3>
            <p>Trusted barber equipment</p>
          </article>
          <article className="home-page__trust__item">
            <h3>Reliable fulfillment</h3>
            <p>Carefully packed and shipped</p>
          </article>
          <article className="home-page__trust__item">
            <h3>Real support</h3>
            <p>Help when you need it</p>
          </article>
        </div>
      </section>
    </>
  );
};

export default Page;
